<div class="calendar-dark-view" (click)="closeCalendar()">
  <div class="calendar-container" id="calendar">
    <div class="calendar-top-div">
      <div class="calendar-top-div-pre" (click)="previousMonth()">
        <img class="calendar-pre-img" src="assets/general/back-blue.svg" />
      </div>
      <div class="calendar-top-div-title">{{ title }}</div>
      <div class="calendar-top-div-next" (click)="nextMonth()">
        <img class="calendar-next-img" src="assets/general/back-blue.svg" />
      </div>
    </div>
    <div class="calendar-weekdays">
      <div *ngFor="let weekDay of weekDaysTitle" class="calendar-weekday">
        {{ weekDay }}
      </div>
    </div>
    <div class="calendar-line"></div>
    <div class="calendar-days">
      <div
        *ngFor="let day of days"
        class="calendar-day"
        (click)="selectDay(day)"
      >
        <div *ngIf="day != -1 && day != calendarToday" style="color: #414141">
          {{ day }}
        </div>
        <div *ngIf="day == -1 && day != calendarToday" style="color: white">
          {{ day }}
        </div>
        <div *ngIf="day == calendarToday" class="calendar-selected-day">
          {{ day }}
        </div>
      </div>
    </div>
    <div class="calendar-line"></div>
    <div class="calendar-bot-div">
      <div class="calendar-today" (click)="selectToday()">امروز</div>
    </div>
  </div>
</div>
